export default __webpack_public_path__ + "static/media/check-secondary-icon.23704525.svg";